import { Component, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormControlsContainerField } from './form-controls-container.modal';
import { FormFieldService } from '../../services/form-field.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'gio-form-controls-container',
  templateUrl: './form-controls-container.component.html',
  styleUrls: ['./form-controls-container.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormControlsContainerComponent extends FormBaseComponent<FormControlsContainerField> {

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
  }
  onComponentDestroy() { }

}
